export default __webpack_public_path__ + "static/media/reports_view.e1f54719.png";